// extracted by mini-css-extract-plugin
module.exports = {"cont-clinic":"cont-clinic","contClinic":"cont-clinic"};